<template>
<!-- left panel and the 'Title' part -->
<v-layout column wrap style="overflow:hidden">
  <div v-if="activeTab === 0" style="background-color:#191a1c; height:80px; width:240px; z-index:8; position: absolute; left:3.7%;top:58px"></div>
  <v-flex id="nodeLegend" >
    <v-layout v-if="activeTab === 0">
      <v-layout column>
         <!-- <span dark class="mx-2" style="font-size:20px; color:#fff">Story Name</span> -->
           <div style="width: 200px; text-align:center; border:1px solid #fff;padding:10px;"><span dark class="mx-2" style="font-size:13px; text-transform:uppercase; color:#fff">title: {{storyTitle}}</span></div>
      </v-layout>
      <v-flex v-for="item in nodesTitleLegend" :key="item.name">
        <v-btn :disabled="item.disabled" id="addNode" style="margin-bottom:0;" round @click="addNode(item.name)"  small flat slot="activator" :color="item.color">
          {{item.name}}<v-icon :color="item.color" style="font-size:13px" class="ml-1">fas {{ item.icon }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex>
            <v-btn style="background-color:#121212;" round color="#FF9D42"  @click="showStories=true" flat small slot="activator">
                Import
            </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  <template style="margin:0 auto; text-align:center">
    <v-spacer style="height:48px !important"></v-spacer>
    <v-flex offset-3 style="position:absolute; z-index:11;right:580px;top:10px" v-if="savedTree">
      <v-icon color="#08d43f">folder_open</v-icon>
      <span style="color: #08d43f">All your changes are saved</span>
    </v-flex>
    <v-flex offset-3 style="position:absolute; z-index:11;right:580px;top:10px" v-if="exportedJson">
      <v-icon color="#08d43f">cloud_upload</v-icon>
      <span style="color: #08d43f">Exported your story</span>
    </v-flex>
    <template>
      <v-tooltip style="z-index:999" right>
         <template style="" v-slot:activator="{ on }">
          <v-btn style="margin: 0px auto 5px auto; width:40px; min-width:0px !important;" color="#909090"  v-on="on"  @click="saveTreeToDB" flat small slot="activator">
            <v-icon style="">folder_open</v-icon>
          </v-btn>
        </template>
        <span>Save</span>
      </v-tooltip>
      <v-tooltip style="z-index:999" right>
         <template v-slot:activator="{ on }">
          <v-btn style="margin: 0px auto 5px auto; width:40px; min-width:0px !important;" color="#909090"  v-on="on"  @click="exportFile" flat small slot="activator">
            <v-icon style="">cloud_upload</v-icon>
          </v-btn>
        </template>
        <span>Upload JSON</span>
      </v-tooltip>
      <v-tooltip style="z-index:999" right>
         <template style="" v-slot:activator="{ on }">
          <v-btn style="margin: auto; width:40px; min-width:0px !important;" color="#909090"  v-on="on"  @click="share = !share" flat small slot="activator">
            <v-icon>share</v-icon>
          </v-btn>
        </template>
        <span>share</span>
      </v-tooltip>
      <v-dialog v-model="share" max-width="500">
        <share-card
          v-bind:story-i-d="storyID">
        </share-card>
      </v-dialog>
      <v-spacer style="height:360px !important"></v-spacer>
      <template id="timelineIcons">
        <v-tooltip right>
          <template style="" v-slot:activator="{ on }">
            <v-btn style="margin: 0px auto 5px auto; width:40px; min-width:0px !important;" color="#909090"  v-on="on" flat small slot="activator">
              <v-icon style="font-size:20px;">far fa-clone</v-icon>
            </v-btn>
          </template>
          <span>Duplicate</span>
        </v-tooltip>
        <v-tooltip right>
          <template style="" v-slot:activator="{ on }">
            <v-btn style="margin: 0px auto 5px auto;width:40px; min-width:0px !important;" color="#909090" v-bind:style="{opacity: selectedAnimation ? 1.0 : 0.5}"  v-on:click="removeAnimation" v-on="on"  flat small slot="activator">
              <v-icon style="font-size:20px; ">far fa-trash-alt</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <v-divider style="border:1px solid #121212; margin:10px auto;"></v-divider>
        <v-tooltip right>
          <template style="" v-slot:activator="{ on }">
            <v-btn style="margin: 0px auto 5px auto; width:40px; min-width:0px !important;" color="#909090"  v-on="on"   flat small slot="acivator">
              <v-icon style="font-size:20px;">fas fa-arrows-alt-v</v-icon>
            </v-btn>
          </template>
          <span>Vertical Expansion</span>
        </v-tooltip>
        <v-tooltip right>
          <template style="" v-slot:activator="{ on }">
            <v-btn style="margin: auto; width:40px; min-width:0px !important;" color="#909090"  v-on="on" flat small slot="activator">
              <v-icon style="font-size:20px;">fas fa-arrows-alt-h</v-icon>
            </v-btn>
          </template>
          <span>Horizontal Expansion</span>
        </v-tooltip>
      </template>
    </template>
    <!-- select story to paste -->
    <!-- <div style="height:20px; width:100%; border:1px solid red;position:absolute; background-image: linear-gradient(to right,rgb(255,255,255,0.3),rgb(255,255,255,0.2));"></div> -->
    <v-dialog style="overflow:scroll;" v-model="showStories" max-width="430" id="#pasteStoryDialog">
      <v-card style="height:auto !important; overflow:scroll;" max-height="auto">

        <v-btn style="position:absolute; right:15px; top:25px" icon dark @click="showStories=false"><v-icon color="grey">close</v-icon></v-btn>
        <v-flex id="importStoryTitleBg"><v-card-title id="importStoryTitle"> Import story</v-card-title>
        <span id="importStoryDialogDescription" class="#949494"> Import your story from your list.</span>
        </v-flex>
        <!-- <v-flex style="width:83%; margin-left: auto; margin-right: auto; margin-bottom:20px; height:1px;background-color:#ccc;"></v-flex> -->
          <v-container style="padding:0">
            <v-flex style="padding-left:5%; width:90%; margin-top:20px;margin-bottom:10px"><span id="storyListTitle">story List</span></v-flex>
            <v-flex v-for="(story, index) in stories" :key="index">
            <div class="text-xs-center">
            <v-layout row>
              <div id="importBtn" style="width:100%;">
                <span v-if="story.title.length <= 25" style="position:absolute; padding-left:3%; padding-top:5px;">{{ story.title }}</span>
                <span v-else style="position:absolute; padding-left:5%; padding-top:5px;">{{ story.title.substr(0,25)+'...' }}</span>
                <v-btn style=" margin-left:65%; background-color:#3F51B5; color:#fff; text-decoration:none; border-radius:20px" small  @click="showSelectedStoryNodes(story.diagramData)">import</v-btn>
              </div>
            </v-layout>
            </div>
          </v-flex></v-container>
        <v-card-actions >

          <div class="flex-grow-1"></div>
          <!-- <v-btn style="border:1px solid grey; color:grey;" text @click="showStories=false">Cancel</v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- show all the nodes of selected story to paste -->
      <v-dialog v-model="showSelectedStoryNodesDialog"  max-width="430">
      <v-card style="background-color:#EEEEEE; height:420px; overflow:scroll !important">
        <v-container class="pa-0" style="margin-top:20px">
          <div style="background-color:#e0e0e0; padding:20px; width:100%;">
          <span style="font-size:18px">Story Nodes</span><br>
          <span style="font-size:15px; margin-bottom:30px" class="grey--text">Select all nodes to import</span>
          </div>
        <v-container style="width:85%;">
          <v-select
            v-model="nodesWaitedToBePasted"
            :items="nodeDataArray"
            item-text="title"
            return-object
            attach
            chips
            label="nodes"
            multiple
          ></v-select>
        </v-container>
        </v-container>
        <v-container style="width:90%; text-align:right; padding-top:120px">
        <v-btn style=" background-color:#3F51B5; color:#fff; border-radius:20px" small  @click="importNodes">Import</v-btn>
        <v-btn style="border:1px solid grey; color:grey; border-radius:20px" small @click="showSelectedStoryNodesDialog=false">Cancel</v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </template>

  <!-- <v-flex xs1>
    <v-btn @click="help = !help" flat small slot="activator" class="help">
      <v-icon left>help</v-icon>
      <span> Help </span>
    </v-btn>
    <v-dialog v-model="help" max-width="500">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Help and Instruction
        </v-card-title>
        <v-card-text>
          <span>Welcome to iBegoo! Here are some instructions:</span>
          <span></span>
          <span></span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="help = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex> -->
  <!-- create story button on the left button -->
  <!-- <v-flex class="createStory">
    <create-story>
    </create-story>
  </v-flex> -->
</v-layout>
</template>

<script>
import {db, timelinesRef} from '../../firebaseDB'
import ShareCard from '../story-edit-view/sharecard'
import { parseExport } from '../../data/export-parser'
import go from 'gojs'
import _ from 'lodash'

export default {
  props: [ //  the props is a String Array, but in fact , each prop have its own data type
    'editor',
    'model',
    'diagram',
    'diagramData',
    'currentNode',
    'saveTimeline',
    'removeAnimation',
    'selectedAnimation',
    'logicNodeType',
    // 'getTimelineById',
    'previewFullScreen',
    'activeTab',
    'worldScaleFactor'
  ],
  data () {
    return {
      nodesTitleLegend: [
        {
          name: 'Scene',
          icon: 'fa-video',
          color: '#f634a5',
          disabled: true
        },
        {
          name: 'User',
          icon: 'fa-user',
          color: '#bf975f',
          disabled: true
        },
        // {
        //   name: 'Universal',
        //   icon: 'lens',
        //   color: '#fff',
        //   disabled: true
        // },
        {
          name: 'Logic',
          icon: 'fa-puzzle-piece',
          color: '#8debd2',
          disabled: true
        }
        // {
        //   name: 'Chatbot',
        //   icon: 'fa-robot',
        //   color: '#643dff',
        //   disabled: true
        // }
      ],
      share: false,
      counters: null,
      unsavedChanges: false,
      savedTree: false,
      exportedJson: false,
      // paste story
      showStories: false,
      showSelectedStoryNodesDialog: false,
      nodeDataArray: [],
      nodesWaitedToBePasted: [],
      linkDataArray: [],
      timelineIdToBePasted: null,
      // paste story
      colors: {
        'Scene': '#f634a5',
        'User': '#bf975f',
        'Logic': '#8debd2',
        'Chatbot': '#643dff',
        'Universal': 'black'
      },
      isSceneAfterRoot: false,
      // isLogicAfterScene: false,
      isNodeAfterCurrentNode: false,
      storyTitle: ''
    }
  },
  mounted () {
    this.editor.signals.logicNodeUserNodeCountChanged.add(this.logicNodeUserNodeCountChanged)
    this.editor.signals.logicNodeSceneNodeCountChanged.add(this.logicNodeSceneNodeCountChanged)
    this.editor.signals.addUserWithText.add(this.addUserWithText)
    // this.editor.signals.userNodeTypeChanged.add(this.userNodeTypeChanged)
    this.storyTitle = this.$route.params.title
  },
  components: {
    ShareCard
  },
  computed: {
    storyID () {
      return this.$route.query.id
    },
    stories () {
      let exStories = []
      this.$store.getters.exsistingStories.forEach(story => {
        exStories.push(story)
      })
      return exStories
    }
  },
  watch: {
    'currentNode.data' (val) {
      // there may have a bug, should add 'deep = true'
      if (this.currentNode) {
        this.updateSidebar(val.category)
      }
    },
    logicNodeType () {
      if (this.currentNode) {
        this.updateSidebar(this.currentNode.data.category)
      }
    },
    currentNode () {
      if (this.currentNode === null) {
        this.nodesTitleLegend.forEach(node => {
          node.disabled = true
        })
      }
    }
  },
  beforeDestroy () {
    this.saveTreeToDB()
  },
  methods: {
    // userNodeTypeChanged () {
    //   const parentNode = this.currentNode.findTreeParentNode()
    //   const linksFromParent = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === parentNode.data.key)
    //   const linkedNodesFromParent = linksFromParent.length ? linksFromParent.map(link => this.diagram.model.nodeDataArray.find(node => node.key === link.to)).filter(node => node) : []

    //   linkedNodesFromParent.forEach((node, i) => {
    //     if (node.category === 'User' && node.key !== this.currentNode.key) {
    //       this.removeLink(linksFromParent[i])
    //     }
    //   })

    //   const linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === this.currentNode.data.key)
    //   const linkedNodesFrom = linksFrom.length ? linksFrom.map(link => this.diagram.model.nodeDataArray.find(node => node.key === link.to)).filter(node => node) : []

    //   // the following code ensures a user node only has two scene nodes. this rule only seems to be important if user node is "Non-Verbal" -dj
    //   let sceneCounter = 0
    //   linkedNodesFrom.forEach((childNode, i) => {
    //     if (childNode.category === 'Scene') {
    //       if (sceneCounter >= 2) {
    //         this.removeLink(linksFrom[i])
    //       } else {
    //         sceneCounter++
    //       }
    //     }
    //   })

    //   for (; sceneCounter <= 1; sceneCounter++) {
    //     this.addNode('Scene')
    //   }
    // },
    logicNodeUserNodeCountChanged (value) {
      console.log(this.storyID)
      let linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === this.currentNode.data.key)
      let linkedNodes = linksFrom.length ? linksFrom.map(link => this.diagram.model.nodeDataArray.find(node => node.key === link.to)).filter(node => node) : []

      let userNodeCounter = 0
      linkedNodes.forEach((node, i) => {
        if (node.category === 'User' || node.category === 'Chatbot') {
          if (node.category === 'User') {
            userNodeCounter++
          }
        } else {
          this.removeLink(linksFrom[i])
        }
      })

      let numberOfNodesToCreateOrDelete = value - userNodeCounter

      if (numberOfNodesToCreateOrDelete > 0) {
        for (let i = 0; i < numberOfNodesToCreateOrDelete; i++) {
          this.addNode('User')
        }
      } else if (numberOfNodesToCreateOrDelete < 0) {
        let connectedUserNodes = linkedNodes.filter(node => node.category === 'User')
        for (let i = 0; i < Math.abs(numberOfNodesToCreateOrDelete); i++) {
          let nodeToDelink = connectedUserNodes[i]
          let linksFromIndex = linkedNodes.findIndex(linkedNode => linkedNode === nodeToDelink)
          this.removeLink(linksFrom[linksFromIndex])
        }
      }
    },
    logicNodeSceneNodeCountChanged (value) {
      let linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === this.currentNode.data.key)
      let linkedNodes = linksFrom.length ? linksFrom.map(link => this.diagram.model.nodeDataArray.find(node => node.key === link.to)).filter(node => node) : []

      let sceneNodeCounter = 0
      linkedNodes.forEach((node, i) => {
        if (node.category === 'Scene') {
          sceneNodeCounter++
        } else {
          this.removeLink(linksFrom[i])
        }
      })

      let numberOfNodesToCreateOrDelete = value - sceneNodeCounter

      if (numberOfNodesToCreateOrDelete > 0) {
        for (let i = 0; i < numberOfNodesToCreateOrDelete; i++) {
          this.addNode('Scene')
        }
      } else if (numberOfNodesToCreateOrDelete < 0) {
        let connectedSceneNodes = linkedNodes.filter(node => node.category === 'Scene')
        for (let i = 0; i < Math.abs(numberOfNodesToCreateOrDelete); i++) {
          let nodeToDelink = connectedSceneNodes[i]
          let linksFromIndex = linkedNodes.findIndex(linkedNode => linkedNode === nodeToDelink)
          this.removeLink(linksFrom[linksFromIndex])
        }
      }
    },
    importNodes () {
      // close the dialog
      this.showSelectedStoryNodesDialog = false
      // deep copy the nodes from selected nodes
      // In case of affecting the original story where nodes were copy from
      let nodesCopy = _.cloneDeep(this.nodesWaitedToBePasted)
      // deep copy the links from selected nodes
      // In case of affecting the original story where nodes were copy from
      // Note: links and nodes are stored seperatly
      let linksCopy = _.cloneDeep(this.linkDataArray)
      // Deep copy the links again, because while we updating the link
      // we still need the original links data as the template, templateLinks will not be changed
      let templateLinks = _.cloneDeep(this.linkDataArray)
      if (this.diagram.model !== null) {
        let model = this.diagram.model
        // this is where model of go.js start to listen the changes of nodes and links
        model.startTransaction()
        // Copy each of selected node
        nodesCopy.forEach(node => {
          let counter = this.getCounters()
          let newKey = counter.max + 1
          // if linksCopy is 0 -> 1, 1 -> 2, there are two nodes in current canvas,
          // we need to update the linksCopy to 2 -> 3, 3 -> 4
          this.updateLinkForThisNode(node, newKey, linksCopy, templateLinks)
          node.key = newKey
          this.updateNodeTitleAndCategoryNum(node, counter)
          // If Scene node is waited to be copied, timeline elements also need to be copied
          if (node.timelineId) {
            this.fetchParentSceneTimeline(node.timelineId, node, node.title)
          }
          // We need to delete __gohashid, so that committing new node in current canvas, go.js will assign you new __gohashid
          // otherwise __gohashid will stays the same as original, go.js will assign you a new one
          delete node.__gohashid
          model.addNodeData(node)
        })
        // map the nodes key with linkDataArray(linkCopy)
        this.updateLinksGraph(linksCopy, nodesCopy, model)
        this.diagramData.linkDataArray = model.linkDataArray
        model.commitTransaction('added Node and Link')
      }
      this.nodesWaitedToBePasted = []
      this.saveTreeToDB()
    },
    updateNodeTitleAndCategoryNum (node, counter) {
      let categoryNum = 0
      if (node.category === 'Scene') {
        categoryNum = counter.maxS
      } else if (node.category === 'User') {
        categoryNum = counter.maxU
      } else if (node.category === 'Logic') {
        categoryNum = counter.maxL
      } else if (node.category === 'Chatbot') {
        categoryNum = counter.maxD
      }
      let nodeNo = categoryNum + 1
      node.categoryNum = nodeNo
      node.title = node.category + ' ' + nodeNo
    },
    updateLinksGraph (linksCopy, nodesCopy, model) {
      // map the nodes key with linkDataArray(linkCopy)
      linksCopy.forEach(link => {
        nodesCopy.forEach(node => {
          if (node.key === link.from) {
            nodesCopy.forEach(toNode => {
              if (toNode.key === link.to) {
                if (typeof link.text !== 'undefined') {
                  let newLink = { from: node.key, to: toNode.key, 'text': link.text }
                  model.addLinkData(newLink)
                } else {
                  let newLink = { from: node.key, to: toNode.key }
                  model.addLinkData(newLink)
                }
              }
            })
          }
        })
      })
    },
    showSelectedStoryNodes (diagramData) {
      this.showStories = false
      this.showSelectedStoryNodesDialog = true
      this.nodeDataArray = diagramData.nodeDataArray.filter(node => node.title !== 'Root')
      this.linkDataArray = diagramData.linkDataArray
    },
    updateLinkForThisNode (node, newKey, linksCopy, templateLinks) {
      templateLinks.forEach((link, index) => {
        if (link.from === node.key) {
          linksCopy[index].from = newKey
        } else if (link.to === node.key) {
          linksCopy[index].to = newKey
        }
      })
    },
    checkIfSceneAfterRoot () {
      let root = this.diagramData.nodeDataArray.find(node => node.category === 'Root')
      let rootKey = root.key
      let rootLink = this.diagramData.linkDataArray.find(link => link.from === rootKey) // link behind root
      if (typeof rootLink === 'undefined') {
        this.isSceneAfterRoot = false
      } else {
        this.isSceneAfterRoot = true
      }
    },
    // depending on the current node type, determine
    // which nodes can be added ( disable = false )
    updateSidebar (category) {
      switch (category) {
        case 'Root':
          this.disabledAllNodes()
          let allowedNodeForRoot = this.nodesTitleLegend.find(node => node.name === 'Scene')
          if (this.diagramData.linkDataArray) {
            this.checkIfSceneAfterRoot()
          }
          if (!this.isSceneAfterRoot) {
            allowedNodeForRoot.disabled = false
          } else {
            allowedNodeForRoot.disabled = true
          }
          break
        case 'Scene':
          this.disabledAllNodes()
          this.checkIfNodeAfterCurrentNode(this.currentNode.data.key)
          let allowedNodesForScene = this.nodesTitleLegend.filter(
            node => node.name === 'Scene' || node.name === 'Logic'
          )
          if (!this.isNodeAfterCurrentNode) {
            allowedNodesForScene.forEach(node => {
              node.disabled = false
            })
          }
          break
        case 'Logic':
          this.disabledAllNodes()
          // if (this.currentNode.data.logicNodeType === 'Conditional') {
          //   this.nodesTitleLegend.forEach(node => {
          //     node.disabled = true
          //   })
          //   let allowedNodeForLogicConditional = this.nodesTitleLegend.find(node => node.name === 'User')
          //   allowedNodeForLogicConditional.disabled = false
          // } else {
          //   this.nodesTitleLegend.forEach(node => {
          //     node.disabled = true
          //   })
          //   let allowedNodeForLogic = this.nodesTitleLegend.find(node => node.name === 'Scene')
          //   allowedNodeForLogic.disabled = false
          // }
          break
        case 'User':
          this.disabledAllNodes()
          this.checkIfNodeAfterCurrentNode(this.currentNode.data.key)
          if (!this.isNodeAfterCurrentNode) {
            let allowedNodeForUser = this.nodesTitleLegend.find(node => node.name === 'Scene')
            allowedNodeForUser.disabled = false
          }
          break
        case 'Chatbot':
          this.disabledAllNodes()
          let allowedNodeForChatbot = this.nodesTitleLegend.find(node => node.name === 'Scene')
          allowedNodeForChatbot.disabled = false
          break
      }
    },
    checkIfNodeAfterCurrentNode (nodeKey) {
      this.isNodeAfterCurrentNode = false
      let linkFromCurrentNode = this.diagramData.linkDataArray.find(link => link.from === nodeKey)
      if (linkFromCurrentNode) {
        this.isNodeAfterCurrentNode = true
      }
    },
    // checkIfLogicAfterScene (sceneKey) {
    //   this.isLogicAfterScene = false
    //   let linkFromCurrentScene = this.diagramData.linkDataArray.find(link => link.from === sceneKey)
    //   if (linkFromCurrentScene) {
    //     let nodeKeyAfterCurrentScene = linkFromCurrentScene.to
    //     this.diagramData.nodeDataArray.forEach(node => {
    //       if (node.key === nodeKeyAfterCurrentScene && node.category === 'Logic') {
    //         this.isLogicAfterScene = true
    //       }
    //     })
    //   }
    // },
    disabledAllNodes () {
      this.nodesTitleLegend.forEach(node => {
        node.disabled = true
      })
    },
    removeLink (linkToRemove) {
      this.currentNode.diagram.model.removeLinkData(linkToRemove)
    },
    addNode (title) { // add a node to the tree
        // this.sheet = false
      // this.saveTreeToDB()
      if (this.diagram.model !== null) {
        let model = this.diagram.model
        model.startTransaction()
        // let isLogic = false
        let isFirst = false // if this node is the root
        let categoryNum = 0
        let counter = this.getCounters()
          /* if (this.onboarding === 2) {
            counter = this.counters3
          }
          if (this.onboarding === 1) {
            counter = this.counters2
          } */
        if (title === 'User') {
            // categoryNum = this.counters.maxU
          categoryNum = counter.maxU
            // this.userNum++
        } else if (title === 'Scene') {
          categoryNum = counter.maxS
            // this.sceneNum++
        } else if (title === 'Universal') {
          categoryNum = counter.maxUni
            // this.universalNum++
        } else if (title === 'Logic') {
          // isLogic = true
          categoryNum = counter.maxL
            // this.logicNum++
        } else if (title === 'Chatbot') {
          categoryNum = counter.maxD
            // this.dialogNum++
        } else if (title === 'Root') {
          isFirst = true
        } else {
            // category error
        }
        // if the parent is logic node, update the child percentage
        let parentType = this.currentNode ? this.currentNode.data.category : 'Root'
        let parentNode = null
        if (this.currentNode) {
          parentNode = this.currentNode.data
        }
        // let parentType = diagram.findNodeForKey(parentId).data.category
        // child iterator
        let childIt
        let randomPercent = null

        /*
        *  debug: logic node with specific type bug
        * */

        if (parentType === 'Logic' && title !== 'Chatbot' && title !== 'User') {
          childIt = this.currentNode.findLinksOutOf()
          randomPercent = Math.round((100 / (childIt.count + 1)), 2) + '%'
                  // update previous node
          while (childIt.next()) {
            let child = childIt.value
            // update all percentage for children except for chatbot
            if (this.diagram.findNodeForKey(child.data.to).data.category !== 'Chatbot') {
              child.data.text = randomPercent
              child.updateTargetBindings()
            }
          }
        }
        let color = this.getNodeColor(title)
        let nodeNo = categoryNum + 1 // Node Id
        let nodeTitle = title.toUpperCase() + ' ' + nodeNo
        // key: Number of all types of nodes
        let data = {key: counter.max + 1, title: nodeTitle, category: title, categoryNum: nodeNo, color: color}
        // data is the node that is going to be created
        if (data.category === 'Scene') {
          let parentSceneTimelineId
          if (parentType === 'Scene') {
            parentSceneTimelineId = this.currentNode.data.timelineId
            this.fetchParentSceneTimeline(parentSceneTimelineId, data, nodeTitle)
          } else if (parentNode != null && this.diagramData.linkDataArray && this.foundPreviousScene(parentNode.key) !== -1) { // ?
            let sceneKey = this.foundPreviousScene(parentNode.key)
            parentSceneTimelineId = this.diagramData.nodeDataArray.find(node => node.key === sceneKey).timelineId
            this.fetchParentSceneTimeline(parentSceneTimelineId, data, nodeTitle)
          } else {
            data.timelineId = timelinesRef.push({name: nodeTitle}).key
          }
        } else if (data.category === 'User') {
          data.metaData = []
        }
        let newLink = { from: this.currentNode ? this.currentNode.data.key : 0, to: data.key, 'text': randomPercent }
        model.addNodeData(data)
        model.addLinkData(newLink)
        this.diagramData.linkDataArray = model.linkDataArray
        model.commitTransaction('added Node and Link')
        this.diagram.select(this.diagram.findNodeForData(data))
        // if (isLogic) {
        //   this.addNode('Chatbot')
        // }
        let linkDataArray = this.diagramData.linkDataArray
        if (this.currentNode) {
          let nodesAfterLogic = linkDataArray.filter(link => link.from === this.currentNode.key)
          if (title === 'User' && nodesAfterLogic.length === 1 && parentType === 'Logic') {
            this.addNode('Chatbot')
          }

          if (title === 'User' && parentType === 'Logic') {
            // only applies to logic nodes when conditional
            this.updateNumberOfUserNodes()
          }

          if (title === 'Scene' && parentType === 'Logic') {
            // only applies to logic nodes
            this.updateNumberOfSceneNodes()
          }
        }
        if (title === 'User') {
          // this.currentNode = model.findNodeDataForKey(data.key)
          // this.addNode('Scene')
          this.addSceneAfterUser('Scene', data.key)
        }
        if (isFirst) {
          this.diagram.commandHandler.deleteSelection()
            // let node = diagram.findNodeForKey(0)
          this.diagram.contentAlignment = go.Spot.TopCenter
          this.diagram.requestUpdate()
            // let node = diagram.findNodeForData(data)
            // this.selectionDeleting(node)
          isFirst = false
        }
      }
      this.unsavedChanges = true
    },
    updateNumberOfUserNodes () {
      let linksFrom = this.currentNode.diagram.model.linkDataArray.filter(linkedData => linkedData.from === this.currentNode.data.key)
      let linkedNodes = linksFrom.length ? linksFrom.map(link => this.currentNode.diagram.model.nodeDataArray.find(node => node.key === link.to)).filter(node => node) : []
      let connectedUserNodes = linkedNodes.filter(linkedNode => linkedNode.category === 'User')
      this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfUserNodes').value = connectedUserNodes.length
    },
    updateNumberOfSceneNodes () {
      let linksFrom = this.currentNode.diagram.model.linkDataArray.filter(linkedData => linkedData.from === this.currentNode.data.key)
      let linkedNodes = linksFrom.length ? linksFrom.map(link => this.currentNode.diagram.model.nodeDataArray.find(node => node.key === link.to)).filter(node => node) : []
      let connectedUserNodes = linkedNodes.filter(linkedNode => linkedNode.category === 'Scene')
      this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfSceneNodes').value = connectedUserNodes.length
    },
    addSceneAfterUser (title, userKey) {
      if (this.diagram.model !== null) {
        let model = this.diagram.model
        model.startTransaction()
        let counter = this.getCounters()
        let categoryNum = counter.maxS
        let color = this.getNodeColor(title)
        let nodeNo = categoryNum + 1
        let nodeTitle = title.toUpperCase() + ' ' + nodeNo
        let data = {key: counter.max + 1, title: nodeTitle, category: title, categoryNum: nodeNo, color: color}
        let parentSceneTimelineId
        if (this.foundPreviousScene(userKey) !== -1) {
          let sceneId = this.foundPreviousScene(userKey)
          parentSceneTimelineId = this.diagramData.nodeDataArray.find(node => node.key === sceneId).timelineId
          this.fetchParentSceneTimeline(parentSceneTimelineId, data, nodeTitle)
        } else {
          data.timelineId = timelinesRef.push({name: nodeTitle}).key
        }
        let newlink = { from: userKey, to: data.key }
        model.addNodeData(data)
        model.addLinkData(newlink)
        this.diagramData.linkDataArray = model.linkDataArray
        model.commitTransaction('added Node and Link')
        this.diagram.select(this.diagram.findNodeForData(data))
      }
    },

    // copy parentScene's Timeline
    // create a timeline for the scene
    fetchParentSceneTimeline (parentSceneTimelineId, data, nodeTitle) {
      // this.getTimelineById(parentSceneTimelineId)
      //   .then(timeline => {
      //     timeline.elements = timeline.elements ? timeline.elements : []
      //     if (timeline.elements.length !== 0) {
      //       this.inheritLastAnimationAndVoice(timeline.elements)
      //     }
      //     data.timelineId = timelinesRef.push({name: nodeTitle, elements: []}).key
      //     this.$emit('updateTimelineId', data.timelineId)
      //   })
      data.timelineId = timelinesRef.push({name: nodeTitle, elements: []}).key
      this.$emit('updateTimelineId', data.timelineId)
    },
    // updateTimeline () {
    //   this.editor.timeline = this.getTimelineById(this.currentNode.timelineId)
    //   console.log('test')
    // },
    getTimelineById (timelineId) {
      return db.ref(`timelines/${timelineId}`).once('value').then(snapshot => snapshot.val())
    },
    inheritLastAnimationAndVoice (elements) {
      elements.forEach(element => {
        if (element.type === 'Character') {
          let animationIdList = element.elements.filter(ele => ele.animation)
          let voiceIdList = element.elements.filter(ele => ele.line)
          let voiceAndAnimation = []
          voiceAndAnimation.push(_.last(animationIdList))
          voiceAndAnimation.push(_.last(voiceIdList))
          this.moveElementsToCharacterStarts(element, voiceAndAnimation)
        }
      })
    },
    moveElementsToCharacterStarts (currentCharacter, characterInheritedElements) {
      let startTimeCharacter = currentCharacter.startTime
      characterInheritedElements.forEach(ele => {
        if (ele.animation) {
          let duration = ele.animation.endTime - ele.animation.startTime
          ele.animation.startTime = startTimeCharacter
          ele.animation.endTime = ele.animation.startTime + duration
        } else if (ele.line) {
          let duration = ele.line.endTime - ele.line.startTime
          ele.line.startTime = startTimeCharacter
          ele.line.endTime = ele.line.startTime + duration
        }
      })
      currentCharacter.elements = [...characterInheritedElements]
    },
    foundPreviousScene (key) {
      let linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === key)
      // continue to track its upper layer throngh the link, till a scene node is found
      while (typeof linkFromThisKey !== 'undefined') {
        let prevNodeKey = linkFromThisKey.from
        let prevNode = this.diagramData.nodeDataArray.find(node => node.key === prevNodeKey)
        if (prevNode.category === 'Scene') {
          return prevNode.key
        }
        linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === prevNode.key)
      }
      return -1
    },
    saveTreeToDB () {
      let rootNode = this.diagramData.nodeDataArray.find(node => node.category === 'Root')
      rootNode['worldScaleFactor'] = parseFloat(this.worldScaleFactor)
      if (this.currentNode) {
        switch (this.currentNode.category) {
          case 'Scene':
            this.saveTimeline()
            break
          default:
            console.log('Saving ' + this.currentNode.category + ' node information...')
        }
      }
      let updates = {}
      // this.updateLogicNode()
      updates[`stories/${this.storyID}/diagramData`] = this.diagramData // this.$store.state.stories.filter(story => story.key === this.storyID)[0].diagramData.nodeDataArray
      db.ref().update(updates)
          .then(snapshot => {
            this.save = false
            if (this.exportedJson) {
              this.exportedJson = false
            }
            this.savedTree = true
            this.unsavedChanges = false
            if (this.savedTree === true) {
              setTimeout(() => {
                this.savedTree = false
              }, 3000)
            }
            console.log('All information saved')
          })
    },
    // updateLogicNode () {
    //   console.log(('update the logic node data structure'))
    //   let logicNodes = []
    //   logicNodes = this.diagramData.nodeDataArray.filter(node => node.category === 'Logic')
    //   for (let i = 0; i < logicNodes.length; i++) {
    //     let conditions = []
    //     let cur = logicNodes[i]
    //     let linksFrom
    //     switch (cur.logicNodeType) {
    //       case 'Specific':
    //         cur['conditionType'] = 'Probability'
    //         linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === cur.key)
    //         for (let j = 0; j < linksFrom.length; j++) {
    //           conditions.push({
    //             'probability': linksFrom[j].text.substr(0, linksFrom[j].text.length - 1) / 100,
    //             'nextNodeID': linksFrom[j].to
    //           })
    //         }
    //         break
    //       case 'Conditional':
    //         if (cur.selectedValues[1].value !== 'Verbal') {
    //           break
    //         }
    //         cur['conditionType'] = 'STT'
    //         linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === cur.key)
    //         for (let j = 0; j < linksFrom.length; j++) {
    //           let child = this.diagram.model.nodeDataArray.find(nodeData => nodeData.key === linksFrom[j].to)
    //           if (child.category === 'User' && child.selectedValues[0].value === 'Verbal') {
    //             let speechPhrase = []
    //             let similarities = []
    //             for (let k = 0; k < child.selectedValues[1].value.length; k++) {
    //               speechPhrase.push(child.selectedValues[1].value[k].value)
    //               // use similarity api here
    //             }
    //             conditions.push({
    //               speechPhrase,
    //               similarities,
    //               'nextNodeID': linksFrom[j].to
    //             })
    //           }
    //         }
    //         break
    //     }
    //     cur['conditions'] = conditions
    //   }
    // },
    getCounters () {
      let maxS = 0
      let maxUni = 0
      let maxU = 0
      let maxD = 0
      let maxL = 0
      let max = 0
      let nodeArray = this.diagram.model.nodeDataArray
      nodeArray.forEach(node => {
        if (node.category === 'Scene') {
          if (node.categoryNum > maxS) {
            maxS = node.categoryNum
          }
          if (node.key > max) {
            max = node.key
          }
        } else if (node.category === 'User') {
          if (node.categoryNum > maxU) {
            maxU = node.categoryNum
          }
          if (node.key > max) {
            max = node.key
          }
        } else if (node.category === 'Universal') {
          if (node.categoryNum > maxUni) {
            maxUni = node.categoryNum
          }
          if (node.key > max) {
            max = node.key
          }
        } else if (node.category === 'Chatbot') {
          if (node.categoryNum > maxD) {
            maxD = node.categoryNum
          }
          if (node.key > max) {
            max = node.key
          }
        } else if (node.category === 'Logic') {
          if (node.categoryNum > maxL) {
            maxL = node.categoryNum
          }
          if (node.key > max) {
            max = node.key
          }
        } else {
        }
      })
      let counters = {
        max,
        maxS,
        maxUni,
        maxU,
        maxD,
        maxL
      }
      return counters
    },
    exportFile () {
      let nodeArray = this.diagramData.nodeDataArray
      let linkArray = this.diagramData.linkDataArray
      parseExport(nodeArray, linkArray, this.storyID)
      if (this.savedTree) {
        this.savedTree = false
      }
      this.exportedJson = true
      if (this.exportedJson === true) {
        setTimeout(() => {
          this.exportedJson = false
        }, 3000)
      }
    },
    getNodeColor (type) {
      return this.colors[type]
     // return 'red'
    },
    addUserWithText (object) {
      let currentNodeKey = this.currentNode.data.key
      this.addNode('User')
      let links = this.diagramData.linkDataArray.filter(link => link.from === currentNodeKey)
      let nodesIds = links.map(link => link.to)
      let userNodes = []
      nodesIds.forEach(id => {
        this.diagramData.nodeDataArray.forEach(node => {
          if (node.key === id && node.category === 'User') {
            userNodes.push(node)
          }
        })
      })
      let sortedUserNodes = _.maxBy(userNodes, o => { return o.key })
      if (object.key) {
        sortedUserNodes.selectedValues[1].value.push(object)
        sortedUserNodes.selectedValues[0].value = 'Verbal'
      } else {
        sortedUserNodes.selectedValues[0].value = 'Non-Verbal'
        sortedUserNodes.selectedValues[2].value.push(object)
      }
    }
  }
}
</script>

<style>
/* .theme--light.v-btn.v-btn--disabled, .theme--light.v-btn.v-btn--disabled .v-btn__loading, .theme--light.v-btn.v-btn--disabled .v-icon {
    color: #888888!important;
} */
</style>



// WEBPACK FOOTER //
// src/components/story-edit-view/leftPanel.vue